/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MentionIcon = /*#__PURE__*/ createSvgIcon(
  'MentionIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.921 18.342c-1.16 0-2.251-.22-3.272-.658a8.502 8.502 0 01-2.682-1.809 8.49 8.49 0 01-1.81-2.685A8.23 8.23 0 011.5 9.91c0-1.163.22-2.252.658-3.268a8.49 8.49 0 014.495-4.485A8.23 8.23 0 019.93 1.5c1.163 0 2.253.22 3.269.658a8.523 8.523 0 014.484 4.485 8.183 8.183 0 01.658 3.278v1.316c0 .802-.281 1.485-.844 2.049a2.788 2.788 0 01-2.05.846c-.498 0-.955-.125-1.371-.373a3.543 3.543 0 01-1.067-.987 4.52 4.52 0 01-1.411.998 4.027 4.027 0 01-1.678.362c-1.165 0-2.158-.412-2.979-1.233-.82-.822-1.231-1.817-1.231-2.983 0-1.166.41-2.159 1.233-2.977.822-.82 1.816-1.228 2.982-1.228 1.166 0 2.159.41 2.977 1.231.82.821 1.229 1.814 1.229 2.979v1.316c0 .368.127.679.383.934.256.254.567.382.932.382.366 0 .677-.128.932-.382.256-.255.384-.566.384-.934V9.92c0-1.9-.665-3.516-1.996-4.846-1.33-1.33-2.945-1.996-4.846-1.996-1.9 0-3.516.665-4.846 1.996-1.33 1.33-1.996 2.945-1.996 4.846 0 1.9.665 3.516 1.996 4.847 1.33 1.33 2.948 1.995 4.854 1.995h3.413c.224 0 .411.075.563.226.15.15.227.337.227.559 0 .222-.076.41-.227.564a.758.758 0 01-.563.23H9.921zm0-5.79c.731 0 1.352-.255 1.864-.767a2.538 2.538 0 00.768-1.864c0-.73-.256-1.352-.768-1.864a2.538 2.538 0 00-1.864-.768c-.73 0-1.352.256-1.864.768a2.538 2.538 0 00-.768 1.864c0 .731.256 1.352.768 1.864a2.538 2.538 0 001.864.768z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default MentionIcon;
